import React from "react";

/**
 * MolecularBg — Carbon Labs background system.
 *
 * Variants (per design brief):
 *   • carbon    — obsidian + brushed noise. Default. Product listing / pages.
 *   • molecular — hex lattice + faint gold nodes. Educational / COA / About.
 *   • vortex    — reserved for hero: circular gold energy trails + hex.
 *
 * `intensity` (low | medium | high) — controls particle density.
 *
 * All existing call sites (`<MolecularBg intensity="high" />` etc.) keep
 * their previous API. Passing a `variant` is opt-in.
 */
export const MolecularBg = ({ intensity = "medium", variant = "carbon" }) => {
    const particleCount = intensity === "high" ? 18 : intensity === "low" ? 6 : 12;
    const particles = Array.from({ length: particleCount }, (_, i) => {
        const size = Math.random() * 2.2 + 0.6;
        const top = Math.random() * 100;
        const left = Math.random() * 100;
        const delay = Math.random() * 10;
        const duration = 14 + Math.random() * 14;
        const goldish = i % 3 !== 0;
        const color = goldish ? "#E6C273" : "#C4C6C8";
        return (
            <span
                key={i}
                className="particle"
                style={{
                    width: size,
                    height: size,
                    top: `${top}%`,
                    left: `${left}%`,
                    animationDelay: `${delay}s`,
                    animationDuration: `${duration}s`,
                    background: color,
                    boxShadow: `0 0 ${size * 4}px ${color}`,
                    opacity: 0.5,
                }}
            />
        );
    });

    return (
        <>
            {variant === "vortex" && <div className="bg-vortex" />}
            {variant === "molecular" && (
                <>
                    <div className="bg-molecular" />
                    <div className="hex-lattice" />
                </>
            )}
            {variant === "carbon" && <div className="bg-carbon" />}
            <div className="grid-bg" />
            <div className="absolute inset-0 z-0 pointer-events-none">{particles}</div>
        </>
    );
};
